export default {
  SET_BREADCRUMBS: (state: any, list: any) => {
    state.breadcrumbs = list
  }
}
